// extracted by mini-css-extract-plugin
export default {"container":"UsersList_container__8SD4-","user-name":"UsersList_user-name__MPRfz","user-age":"UsersList_user-age__8uc4r"};